/**
 * @file platform.js
 * @description 运行环境检测：移动端、微信内置浏览器、支付场景
 * @module shared/utils/platform
 */

import { MOBILE_LAYOUT_MAX_WIDTH } from '@/shared/utils/mobileLayout'

/** @typedef {'PC_NATIVE' | 'MOBILE_GUIDE' | 'JSAPI'} PayScene */

/** @typedef {'NATIVE' | 'H5' | 'JSAPI'} WechatPayScene */

/**
 * 是否为微信内置浏览器
 * @returns {boolean}
 */
export function isWeChatBrowser() {
  if (typeof navigator === 'undefined') return false
  return /MicroMessenger/i.test(navigator.userAgent || '')
}

/**
 * 是否为移动设备（UA 或窄视口）
 * @returns {boolean}
 */
export function isMobileDevice() {
  if (typeof window === 'undefined') return false
  const uaMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent || ''
  )
  return uaMobile || window.innerWidth <= MOBILE_LAYOUT_MAX_WIDTH
}

/**
 * 是否为移动端非微信浏览器（不走 H5 支付，引导复制链接到微信）
 * @returns {boolean}
 */
export function isMobileExternalBrowser() {
  return isMobileDevice() && !isWeChatBrowser()
}

/**
 * 解析当前支付场景
 * @returns {PayScene}
 */
export function getPayScene() {
  if (isWeChatBrowser()) return 'JSAPI'
  if (isMobileExternalBrowser()) return 'MOBILE_GUIDE'
  return 'PC_NATIVE'
}

/**
 * 前端支付场景 → 后端 prepare.scene（MOBILE_GUIDE 不应传入，提交前已拦截）
 * @param {PayScene} scene
 * @returns {WechatPayScene}
 */
export function toWechatPayScene(scene) {
  if (scene === 'PC_NATIVE') return 'NATIVE'
  return 'JSAPI'
}
